export function assert(condition: boolean, message = 'Assertion failed'): asserts condition {
  if (!condition) throw new Error(message);
}

export function assertIsKeyOf<T extends object>(
  key: string,
  obj: T,
): asserts key is keyof T & string {
  if (!(key in obj)) throw new Error(`Unknown key: ${key}`);
}

export const exhausted = (exhaustable: never, message = 'Unknown action') => {
  throw new Error(`${exhaustable} ${message}`);
};
